export const CUSTOMER_TESTING_REPORTS = {
  REPORT: 'customer-testing-reports/report',
} as const
